<template>
    <div class="detail-view">
        <div class="tag-top-detail player-detail">
            <age-tag :age-code="contentInfo.targetage"></age-tag>
            <div class="tag-top">
              <span v-if="contentInfo.type === 'onair'" class="tag-quick-vod">Quick VOD</span>
              <span v-if="contentInfo.type !== 'onair' && contentInfo.update === 'y'" class="tag-update">업데이트</span>
              <span v-if="contentInfo.price === '0'" class="tag-free">무료</span>
              <span v-if="contentInfo.drms !== ''" class="tag-drm">DRM</span>
            </div>
        </div>

        <div class="title-box" @click.prevent="toggleInfo">
            <p class="view-title">
              {{contentInfo.episodenumber ? contentInfo.episodenumber+'회':''}} <span v-html="contentInfo.programtitle"></span>
            </p>
            <span class="info-toggle-button">
              <component :is="getToggleButton"></component>
            </span>
            <!--<p class="view-sub-title">서브텍스트</p>-->
        </div>

        <div class="desc-info-box">
          <span class="desc-info">
            <span>{{contentInfo.releasedate}}({{contentInfo.releaseweekday}})</span>
            <i class="icon-dotted"></i><span>{{contentInfo.genretext}}</span>
            <i class="icon-dotted"></i><span>{{Math.floor(contentInfo.playtime / 60)}}분</span>
          </span>
        </div>

        <div class="icon-wrap">
          <icon-box-sns-share :content-info="contentInfo"></icon-box-sns-share>
          <icon-box-zzim :content-info="contentInfo"></icon-box-zzim>
          <icon-box-program :content-info="contentInfo"></icon-box-program>
        </div>
        <div class="tag-hash" v-if="tagList.length > 0">
          <ul>
            <li @click="clickTag(tag)" v-for="(tag, index) in tagList" :key="tag.value + index">#{{tag.text}}</li>
          </ul>
        </div>

    </div>
</template>
<script>
import AgeTag from '@/components/tags/AgeTag'
import { topTagList } from '@/common/directives'
import OpenInfoButton from '@/assets/svg/common/ic_title_open_b.svg'
import CloseInfoButton from '@/assets/svg/common/ic_title_close_b.svg'
import IconBoxProgram from '@/components/play/IconBoxProgram'
import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
import IconBoxZzim from '@/components/play/IconBoxZzim'
export default {
  name: 'VodPlayerDetailInfo',
  components: {
    IconBoxZzim,
    IconBoxProgram,
    IconBoxSnsShare,
    OpenInfoButton,
    CloseInfoButton,
    AgeTag
  },
  directives: {
    topTagList
  },
  data () {
    return {
      isOpenInfoPopup: false
    }
  },
  props: {
    contentInfo: {
      type: Object
    },
    getToggleButton: {
      type: String
    },
    toggleInfo: {
      type: Function
    },
    tagList: {
      type: Array
    },
    clickTag: {
      type: Function
    }
  }
}
</script>
<style scoped>

</style>
